// @flow
import i18n from "i18next";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
// import { FcGlobe } from "react-icons/fc";
import { MdLanguage } from "react-icons/md";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  UncontrolledTooltip,
} from "reactstrap";
import { EN, IT, LANGUAGE, SR } from "../../constants/cookieConsts";
import { setCookie } from "../../helpers/other/cookies";
import italyFlag from "./flags/italy.jpg";
import serbiaFlag from "./flags/serbia.png";
import usFlag from "./flags/us.jpg";

const LanguageDropdown = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  /* constructor(props) {
        super(props);
        toggleDropdown = toggleDropdown.bind(this);

        state = {
            dropdownOpen: false,
        };
    } */

  // const [dropdownOpen, setDropdown] = useState(dropdownOpen);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const tag = props.tag || "div";

  return (
    <React.Fragment>
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggleDropdown}
        className="d-md-block d-flex align-items-center justify-content-center"
        tag={tag}
        id="langDropdown"
      >
        <DropdownToggle
          data-toggle="dropdown"
          tag="a"
          className="nav-link mr-0 "
          style={{ paddingLeft: "4px" }}
          onClick={toggleDropdown}
          aria-expanded={dropdownOpen}
        >
          {/* <FcGlobe /> */}
          <MdLanguage
            style={{
              color: "black",
              fill: "black",
              fontSize: "24px",
              cursor: "pointer",
            }}
          />
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-wc">
          <div onClick={toggleDropdown}>
            {/* English */}
            <button
              onClick={() => {
                setCookie(LANGUAGE, EN);
                return i18n.changeLanguage(EN);
              }}
              className="dropdown-item notify-item"
            >
              <img src={usFlag} alt="English" className="mr-1" height="12" />{" "}
              <span className="align-middle">
                {props.t("LANGUAGE.English")}
              </span>
            </button>
            {/* Serbian Latin */}
            <button
              onClick={() => {
                setCookie(LANGUAGE, SR);
                return i18n.changeLanguage(SR);
              }}
              className="dropdown-item notify-item"
            >
              <img
                src={serbiaFlag}
                alt="Serbian"
                className="mr-1"
                height="12"
              />{" "}
              <span className="align-middle">
                {props.t("LANGUAGE.Serbian")}
              </span>
            </button>
            {/* Serbian Cilyic */}
            {/* <button
              onClick={() => {
                setCookie(LANGUAGE, SRCiryl);
                return i18n.changeLanguage(SRCiryl);
              }}
              className="dropdown-item notify-item"
            >
              <img
                src={serbiaFlag}
                alt="Serbian"
                className="mr-1"
                height="12"
              />{" "}
              <span className="align-middle">
                {props.t("LANGUAGE.SerbianCirilic")}
              </span>
            </button> */}
            {/* Italian */}
            <button
              onClick={() => {
                setCookie(LANGUAGE, IT);
                return i18n.changeLanguage(IT);
              }}
              className="dropdown-item notify-item"
            >
              <img src={italyFlag} alt="Italian" className="mr-1" height="12" />{" "}
              <span className="align-middle">
                {props.t("LANGUAGE.Italian")}
              </span>
            </button>
          </div>
        </DropdownMenu>
      </Dropdown>

      <UncontrolledTooltip
        placement="left"
        target="langDropdown"
        innerClassName="custom-tooltip"
      >
        {props.t("LANGUAGE.Change_lang")}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

LanguageDropdown.propTypes = {
  tag: PropTypes.string, // tag treba da bude string (npr. "div")
  t: PropTypes.func.isRequired, // t je funkcija koja dolazi iz withTranslation
};

export default withTranslation()(LanguageDropdown);
